// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shop-intro-section{padding:1.3rem 0 0}@media (min-width:1024px){.shop-intro-section .centered{justify-content:center;text-align:center}}.shop-intro-section div h4{line-height:36px}.shop-intro-section div>p:last-child{margin-bottom:0}.shop-intro-section .image img{display:block;height:auto;margin:0 auto 120px;max-width:147px;width:100%}@media (min-width:1024px){.shop-intro-section .image img{margin:0}}", ""]);
// Exports
module.exports = exports;
